import style from "./style.module.scss";
import MainSharedComponent from "../mainSharedComponent";
import { DomainInfo } from "@components/severalbrands/utils/services";
const list = [
    {
        img: "/severalbrands/assets/images/communityMarketplace2.png",
        mainTitle: "Built on Trust, Not Big Promises",
        paragraphs: [
            "We don't believe in one-size-fits-all rollouts or big-bang changes. Most partnerships start with a trial run, and we check in regularly, weekly or biweekly, to see how the leads we're sending are actually performing, so we can adjust together before small problems become big ones.",
        ],
        secondSectionClassName: style["secondSectionClassNameMarketPlace"],
        mainSectionClassName: `${style["communityMarketplace"]}`,
        mainTitleClassName: "text-[#fff]",
        textClassName: "text-[#fff]",
        imgToLeft: true,
        imgClassName:
            "w-[250px]  h-[250px] md:w-[413px] md:min-w-[413px] md:h-[409px] 3xl:w-[613px] 3xl:min-w-[613px] 3xl:h-[609px] relative lg:-mt-[140px] 3xl:-mt-[80px]",
    },
    {
        img: "/severalbrands/assets/images/onlyPaySpecific2.png",
        mainTitle: "Only Pay for Specific Deliverables",
        paragraphs: [
            "Our partners pay for specific outcomes, form leads, calls, warm transfers, sales, or scheduled appointments, not a flat retainer. Pricing is performance-based and prepaid, and every lead goes through TCPA compliance checks and TrustedForm certification before it reaches you. We'd rather show you specific deliverables than vanity metrics; impressions and pageviews don't pay your bills, but signed retainers and closed sales do.",
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] lg:px-[90px] px-[40px]`,

        mainTitleClassName: "text-[#351C4F]",

        imgClassName:
            "w-[250px]  h-[200px] md:w-[344px] md:min-w-[344px] md:h-[282px] 3xl:w-[544px] 3xl:min-w-[544px] 3xl:h-[482px] relative ",
    },
    {
        mainTitle: "Experience With Various Industries",
        paragraphs: [
            "For the past decade, we have partnered with hundreds of enterprises and local businesses, helping them generate high-quality leads and live calls. Our expertise spans various industries, including law firms, B2C and B2B enterprises, online businesses, software companies, and more.",
        ],
        mainSectionClassName: `${style["experienceVariousIndustries"]}`,
        mainTitleClassName: "text-[#351C4F] text-center",
        textClassName: "text-[#351C4F]  text-center ",
    },
    {
        img: "/severalbrands/assets/images/collaboratingWithBusinesses2.png",
        mainTitle: "Collaborating With Businesses",
        paragraphs: [
            "For B2B partners, we focus on outbound campaigns and channel strategies aimed at reaching real decision-makers, not cold-call volume. For B2C partners, from auto warranties to hearing aids, we use geo-targeted ads and comparison tools to turn hesitant browsers into customers.",
        ],
        mainSectionClassName: `${style["collaboratingWithBusinesses"]}`,
        mainTitleClassName: "text-[#fff] 3xl:mt-10",
        textClassName: "text-[#fff]",
        imgToLeft: true,
        imgClassName:
            "w-[250px]  h-[200px] md:w-[399px] md:min-w-[399px] md:h-[256px] 3xl:w-[599px] 3xl:min-w-[599px] 3xl:h-[456px] relative ",
    },
    {
        img: "/severalbrands/assets/images/collaboratingWithLawyers2.png",
        mainTitle: "Collaborating With Lawyers",
        paragraphs: [
            "We specialize in mass tort, motor vehicle accident (MVA), and personal injury leads. Through targeted advertising campaigns, we connect law firms with high-intent prospects who are actively seeking legal representation, not just browsing, so your intake team spends less time filtering and more time converting.",
            "These leads go directly to our partner law firms, where your intake team works them through to a signed retainer, and compensation is based on the terms we agree to upfront together.",
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] lg:px-[90px] px-[40px]`,

        mainTitleClassName: "text-[#351C4F]",

        imgClassName:
            "w-[250px]  h-[200px] md:w-[319px] md:min-w-[319px] md:h-[369px] 3xl:w-[519px] 3xl:min-w-[519px] 3xl:h-[569px] relative ",
    },
    {
        img: "/severalbrands/assets/images/generatingHighQuality2.png",
        mainTitle: "High-Intent Leads",
        paragraphs: [
            "We prioritize real-time leads over aged, recycled contacts, generated through our own owned-and-operated properties rather than third-party lists. Each lead is matched against the specific product or case type a campaign is built around, so what reaches you reflects real, current intent, not a guess.",
        ],
        mainSectionClassName: `${style["generatingHighQuality"]}`,
        mainTitleClassName: "text-[#fff] 3xl:mt-10",
        textClassName: "text-[#fff]",
        imgClassName:
            "w-[250px]  h-[200px] md:w-[388px] md:min-w-[388px] md:h-[280px] 3xl:w-[588px] 3xl:min-w-[588px] 3xl:h-[480px] relative ",
    },
    {
        img: "/severalbrands/assets/images/expertiseTrafficGeneration2.png",
        mainTitle: "Dedicated Account Support",
        paragraphs: [
            "We think of ourselves as an extension of your sales team, not just a vendor. Once a partnership starts, you're not handed off to a ticket queue. Our partners work with dedicated account managers focused on lead generation strategy and ongoing optimization; someone who knows your account and can make adjustments as your goals change.",
        ],
        mainSectionClassName: `3xl:gap-[220px] lg:gap-[180px] lg:px-[90px] gap-[40px] px-[40px] `,
        secondSectionClassName: "lg:mt-12",
        mainTitleClassName: "text-[#351C4F] 3xl:mt-10",
        imgToLeft: true,
        imgClassName:
            "w-[250px]  h-[200px] md:w-[400px] md:min-w-[400px] md:h-[396px] 3xl:w-[600px] 3xl:min-w-[600px] 3xl:h-[596px] relative ",
    },
];

export default function ThirdSection({
    domainInfo,
}: {
    domainInfo: DomainInfo;
}) {
    return (
        <section className={`lg:mt-48 mt-24 `}>
            {list.map((el, index) => (
                <div className="lg:mt-36 mt-14 first-of-type:mt-0 " key={index}>
                    <MainSharedComponent info={el} domainInfo={domainInfo} />
                </div>
            ))}
        </section>
    );
}
